import React from "react"
import { ThemeProvider, createTheme } from '@mui/material/styles'
import Layout from "./components/layout/Layout"
import FeedbackSnackbar from "./components/feedback/FeedbackSnackbar"

import useStoreSnackbar from "./stores/storeSnackbar"

import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'

import 'bootstrap/dist/css/bootstrap.min.css'

const mainTheme = createTheme({
  palette: {
    primary: {
      main: '#0d47a1',
    },
    linkedIn: {
      main: '#0e76a8',
    },
    facebook: {
      main: '#3b5998',
    },
    whatsApp: {
      main: '#25d366',
    },
    selectedPage: {
      main: '#e61212',
    },
    notSelected: {
      main: '#0d47a1',
    },
  },
})

export default function App() {

  const snackbarData = useStoreSnackbar((state) => state.snackbarData)
  const setSnackbarData = useStoreSnackbar((state) => state.setSnackbarData)

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarData({
      ...snackbarData,
      open: false,
    })
  }

  return (
    <ThemeProvider theme={mainTheme}>
      <div className="App">     
        <Layout/>
        <FeedbackSnackbar
          open={snackbarData.open}
          message={snackbarData.message}
          handleClose={handleSnackbarClose}
          severity={snackbarData.severity}
        />
      </div>
    </ThemeProvider>
  )
}